import { getRequest, postRequest, getcompanyIdNumber } from './api'

export async function list(size, index, searchTerm, orderBy) {
  searchTerm = searchTerm || '%20';
  orderBy = orderBy || '%20';
  if (!searchTerm.includes('CompanyID'))
    searchTerm = `${searchTerm}, CompanyID:${getcompanyIdNumber()},`;
  return getRequest(`bankInfo/get-list/${parseInt(size, 10) || 10}/${parseInt(index, 10) || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`)
}

export async function find(id) {
  return getRequest(`bankInfo/edit/${id}`)
}

export async function save(values) {
  return postRequest(`bankInfo/save`, values)
}

export function remove(values) {
  return postRequest(`bankInfo/delete`, values)
}
